import { Box, BoxProps, styled } from "@mui/material";
import { FC } from "react";

const StyledFloatingBox = styled(Box)(({ theme }) => ({
  position: "fixed",
  zIndex: "999",
}));

interface IFloatingBoxProps extends BoxProps {}

const FloatingBox: FC<IFloatingBoxProps> = (props) => {
  return <StyledFloatingBox {...props}/>;
}

export default FloatingBox;